import { parseModel } from './SAxsModelMapper'

/** Parse a single subtraction from a LIST API call */
export function parseSubtractions2(subtractions) {
  const result = []
  if (subtractions) {
    subtractions.forEach(subtraction => {
      const parsedSubtraction = {}

      parsedSubtraction.subtractionId = subtraction.subtractionId

      if (
        subtraction.substractionToAbInitioModel3VOs &&
        subtraction.substractionToAbInitioModel3VOs instanceof Array &&
        subtraction.substractionToAbInitioModel3VOs.length > 0
      ) {
        const abInitioModels = subtraction.substractionToAbInitioModel3VOs
        parsedSubtraction.abInitioModels = []
        abInitioModels.forEach(abInitioModel => {
          if (abInitioModel.abinitiomodel3VO) {
            abInitioModel = abInitioModel.abinitiomodel3VO
            const parsedAbInitioModel = {}
            parsedAbInitioModel.abInitioModelId = abInitioModel.abInitioModelId

            if (abInitioModel.averagedModel) {
              const parsedAveragedModel = parseModel(abInitioModel.averagedModel)
              parsedAbInitioModel.averagedModel = parsedAveragedModel
            }
            if (abInitioModel.modelList3VO) {
              const modelList = abInitioModel.modelList3VO
              const parsedModelList = {}
              parsedModelList.modelListId = modelList.modelListId
              if (
                modelList.modeltolist3VOs &&
                modelList.modeltolist3VOs instanceof Array &&
                modelList.modeltolist3VOs.length > 0
              ) {
                const models = modelList.modeltolist3VOs
                const parsedModels = []
                models.forEach(model => {
                  if (model.model3VO) {
                    parsedModels.push(model.model3VO)
                  }
                })
                parsedModelList.models = parsedModels
              }
              parsedAbInitioModel.modelList = parsedModelList
            }

            if (abInitioModel.shapeDeterminationModel) {
              const parsedShapeDeterminationModel = parseModel(abInitioModel.shapeDeterminationModel)
              parsedAbInitioModel.shapeDeterminationModel = parsedShapeDeterminationModel
            }

            if (abInitioModel.rapidShapeDeterminationModel) {
              const parsedRapidShapeDeterminationModel = parseModel(abInitioModel.rapidShapeDeterminationModel)
              parsedAbInitioModel.rapidShapeDeterminationModel = parsedRapidShapeDeterminationModel
            }

            parsedSubtraction.abInitioModels.push(parsedAbInitioModel)
          }
        })
      }
      result.push(parsedSubtraction)
    })
    return result
  }
  return null
}
